module.exports = __webpack_public_path__ + "img/0.59746802.png";